import { render, staticRenderFns } from "./EditDocLabOrga.vue?vue&type=template&id=2e7b58dc&scoped=true"
import script from "./EditDocLabOrga.vue?vue&type=script&lang=js"
export * from "./EditDocLabOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7b58dc",
  null
  
)

export default component.exports